import { FieldTitle } from '../common/index';
import DefaultValue from './defaultValue';
import React from 'react';
import $ from 'jquery';

class Select extends React.Component {
  constructor() {
    super();
    this.state = {
      optionsForSelect: []
    };
  }

  componentDidMount() {
    this.getOptions();
  }

  getOptions() {
    const { options, placeholder } = this.props;

    if (options && {}.hasOwnProperty.call(options, 'for_select')) {
      if (typeof options.for_select === 'string') {
        const uri = options.for_select;
        $.ajax({
          url: uri,
          method: 'GET',
          success: (data) => {
            if (data) {
              this.setState({ optionsForSelect: data });
            }
          }
        });
      } else {
        const optionsForSelect = options.for_select;
        const showPlaceholder = options.hasOwnProperty('show_placeholder') ? options.show_placeholder : true;

        if (showPlaceholder && placeholder) {
          optionsForSelect.unshift({ title: placeholder, value: placeholder, disabled: true });
        }

        this.setState({ optionsForSelect });
      }
    }
  }

  render() {
    const {
      internalTitle,
      formId,
      required,
      label,
      className,
      options,
      placeholder
    } = this.props;
    const optionsForSelect = this.state.optionsForSelect.map((option, index) => (
      <option
        value={option.value}
        disabled={option.disabled}
        key={`select-option-${index}`}
      >
        {option.title}
      </option>
    ));
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;
    const asterisk = required ? ' *' : null;
    const labelForSelect = label.length ? (
      <label htmlFor={forId}>
        {label}
        {asterisk}
      </label>
    ) : null;

    return (
      <div className={`${className} input select`}>
        {labelForSelect}
        <select
          name={internalTitle}
          id={forId}
          required={required}
          defaultValue={placeholder || DefaultValue.selectAutomatically(options, internalTitle)}
          placeholder={placeholder}
        >
          {optionsForSelect}
        </select>
      </div>
    );
  }
}

Select.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  className: React.PropTypes.string,
  formId: React.PropTypes.number,
  placeholder: React.PropTypes.string,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  options: React.PropTypes.object
};

export default Select;



// WEBPACK FOOTER //
// ./components/forms/select.js